import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { LifeBuoy, ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const useTicketCount = (enabled) => {
  const { data } = useQuery({
    queryKey: ["helpdesk-stats-badge"],
    queryFn: async () => (await api.get("/helpdesk/stats")).data,
    enabled,
    refetchInterval: 60_000,
  });
  return (data?.aperta || 0) + (data?.in_lavorazione || 0);
};

export function TicketAlert() {
  const { user } = useAuth();
  const manager = ["admin", "direzione", "segreteria"].includes(user?.role);
  const count = useTicketCount(manager);
  if (!manager || count === 0) return null;
  return (
    <Link
      to="/helpdesk"
      data-testid="ticket-alert"
      className="mb-6 flex items-center gap-3 rounded-xl border border-[#E2725B]/40 bg-[#E2725B]/10 px-4 py-3 text-[#1C352D] hover:bg-[#E2725B]/15 transition-colors duration-150"
    >
      <LifeBuoy size={18} className="text-[#E2725B] shrink-0" />
      <span className="flex-1 text-sm">
        Hai <b data-testid="ticket-alert-count">{count}</b> {count === 1 ? "ticket aperto" : "ticket aperti"} nell'Help Desk
      </span>
      <span className="text-xs font-medium inline-flex items-center gap-1">Apri <ArrowRight size={14} /></span>
    </Link>
  );
}
